var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: props.fill,
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.325 9.75a.8.8 0 01.8-.8h9.75a.8.8 0 010 1.6h-9.75a.8.8 0 01-.8-.8zM6.325 12.75a.8.8 0 01.8-.8h9.75a.8.8 0 010 1.6h-9.75a.8.8 0 01-.8-.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 5.3v12.906l1.842-.921a.8.8 0 01.716 0L9 18.605l2.642-1.32a.8.8 0 01.716 0L15 18.605l2.642-1.32a.8.8 0 01.716 0l1.842.92V5.3zM2.654 4.154A1.55 1.55 0 013.75 3.7h16.5a1.55 1.55 0 011.55 1.55V19.5a.8.8 0 01-1.158.715L18 18.895l-2.642 1.32a.8.8 0 01-.716 0L12 18.895l-2.642 1.32a.8.8 0 01-.716 0L6 18.895l-2.642 1.32A.8.8 0 012.2 19.5V5.25c0-.411.163-.805.454-1.096z"
  }))));
}

export default SvgReceipt;